import { writable } from 'svelte/store';
export const CATEGORY_STORE = writable({});
export const CATEGORY_HASH = writable('initial');
